import { render } from "./colorPicker.vue?vue&type=template&id=f71380c0"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=f71380c0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script